import React from 'react';
import Banner from '../Banner/Banner';
import Services from '../Services/Services';
import WhyHireMe from '../WhyHireMe/WhyHireMe';

const Home = () => {
    return (
        <div>
            <Banner></Banner>
            <Services></Services>
            <WhyHireMe></WhyHireMe>
        </div>
    );
};

export default Home;